import { FunctionComponent } from "react";
import { RouteComponentProps } from "react-router-dom";
import PageLayout from "@components/layouts/PageLayout";
import PageBody from "@components/bodies/PageBody";
import ClientForm from "@views/clients/details/ClientForm";

const ClientAddScreen: FunctionComponent<RouteComponentProps> = () => {
  return (
    <PageLayout>
      <>
        <PageBody>
          <ClientForm editMode />
        </PageBody>
      </>
    </PageLayout>
  );
};

export default ClientAddScreen;
